
export const REPORT_PERMISSIONS = {
  VIEW_INSTRUMENTS: 'rc_export_instrument_csv_report',
  VIEW_ALARMS: 'rc_export_alarm_csv_report',
  VIEW_DATA_ITEMS: 'rc_export_data_item_csv_report',
} as const;

export type ReportsPermissions = typeof REPORT_PERMISSIONS[keyof typeof REPORT_PERMISSIONS];
